var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',_vm._b({staticClass:"button-base",class:_vm.classObject,on:{"click":_vm.clickEvent}},'a',_vm.$attrs,false),[_c('span',{staticClass:"button-base__label"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }